mutation PaymentUploadDocument(
  $document: DocumentUploadInput!
  $paymentId: UUID!
) {
  paymentUploadDocument(document: $document, paymentId: $paymentId) {
    uploadLink
    document {
      _documentFileId
    }
  }
}
